<template>
  <div>
    <div class="img-section text-center">
      <a href="https://onblick.com" title="OnBlick">
        <img src="https://www.onblick.com/Content/Images/BWLogo.png" alt="OnBlick" />
      </a>
    </div>
    <div class="error-content">
      <img
        src="https://www.onblick.com/Content/Images/404Error/error.png"
        width="25%"
        alt="OnBlick 404 Error"
      />
      <p>
        <b>Oops...</b>
      </p>
      <p>The page your'e trying to reach might be removed or broken</p>
    </div>
    <div class="footer-links">
      <ul>
        <li>
          <a href="javascript:;" @click="goBack">
            <img src="https://www.onblick.com/Content/Images/404Error/back.png" alt="Back" />
          </a>
          <span>Back</span>
        </li>
        <li>
          <a href="https://onblick.com">
            <img src="https://www.onblick.com/Content/Images/404Error/home.png" alt="OnBlick" />
          </a>
          <span>Home</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goBack() {
      window.history.back();
    }
  }
};
</script>
<style>
@charset "UTF-8";
@import "https://fonts.googleapis.com/css?family=Open+Sans:400,700,300italic";

html,
body {
  font-family: "Open Sans", sans-serif;
  background: #f3f3f4;
  color: #676a6c;
  font-size: 13px;
  margin: 0;
  padding: 0;
}



h1 {
  font-size: 26px;
}

h2 {
  font-size: 18px;
}

.text-center {
  text-align: center;
}

.img-section {
  background: #143361;
  padding: 10px;
}
.error-content {
  width: 100%;
  text-align: center;
  padding: 8% 0 0 0;
}
.error-content p {
  margin: 5px 0 0 0;
}
.error-content p b {
  font-size: 22px;
}
.error-content p {
  color: #143361;
  font-size: 16px;
  font-weight: 500;
}
.footer-links {
  text-align: center;
  margin-top: 25px;
}
.footer-links ul {
  padding: 10px 0;
}
.footer-links li {
  list-style: none;
  display: inline-block;
  text-align: center;
  width: 75px;
}
.footer-links li img {
  width: 40%;
}
.footer-links a {
  display: block;
}
.footer-links span {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #143361;
}
</style>
<style lang="scss" scoped>
h1,
h2,
p {
  margin: 0 0 15px 0;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/PageNotFound.vue